module.exports = __webpack_public_path__ + "static/media/flag-st.48810a36.webp";